export default {
  en: {
    'pages.general-errors.title': "We're terribly sorry",
    'pages.general-errors.copy':
      "Something unexpected has happened and we're working on it. Please check back later, or feel free to contact us.",
    'pages.general-errors.cta': 'Back to homepage',
  },
};
